/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import { useUser } from '../../../../../../../hooks/shared/user/useUser';
import useCheckDepartment from '../../../../../../../hooks/shared/custom/check-department/useCheckDepartment';
import { LOGGED_IN_USER_URL } from '../../../../../../../services/api/auth/AuthUrl';
import { NEW_PRODUCTS, RESEARCH_AND_DEVELOPMENT, SUPER_ADMIN, VP_FIBER } from '../../../../../../../utils/departments/helpers';
import WifiCallNavBar from '../../../../../../layouts/wificall/WifiCallNavBar';
import ActiveAndInactiveBody from './ActiveAndInactiveBody';
import useCheckTwoDepartments, { useCheckThreeDepartments } from '../../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import useCheckFiveDepartments from '../../../../../../../hooks/shared/custom/check-department/useCheckFiveDepartments';

const WifiCallActiveAndInactiveCustomers = ({ history }) => {
  useCheckFiveDepartments(`${NEW_PRODUCTS}`, `${SUPER_ADMIN}`, `${RESEARCH_AND_DEVELOPMENT}`, `${VP_FIBER}`, history);

  const { profile, user } = useUser();
  const { firstName } = profile;
  const { role_id } = user;

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <WifiCallNavBar currentPage="Active/Inactive Customers" position={firstName} role_id={role_id} />
        <div className="container">
          <div className="row mt-5">
            <ActiveAndInactiveBody />
          </div>
        </div>
      </main>
    </div>
  );
};

WifiCallActiveAndInactiveCustomers.propTypes = {
  history: PropTypes.shape(),
};

export default WifiCallActiveAndInactiveCustomers;
